import { ProductSubstituteItemResponse } from '@/types/service-response'

export class ProductSubstitute {
  public constructor (
    readonly id: number,
    readonly number: string,
    readonly bezeichnung: string,
    readonly text: string
  ) {}

  static createFromResponse (responseData: ProductSubstituteItemResponse): ProductSubstitute {
      return new ProductSubstitute(
        responseData.ID,
        responseData.Nummer ? responseData.Nummer : '',
        responseData.Bezeichnung ? responseData.Bezeichnung : '',
        `${responseData.Nummer ? responseData.Nummer : ''} \n ${responseData.Bezeichnung ? responseData.Bezeichnung : ''}`
      )
  }
}
